import React, { useRef, useState } from 'react';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { useLanguage } from '../context/LanguageContext';

// Μικρό εικονίδιο (i) με κουτί επεξήγησης.
// Ποντίκι: ανοίγει με hover. Αφή/πληκτρολόγιο: ανοίγει/κλείνει με κλικ/Enter.
const InfoTip = ({ text, testId }) => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const pointerType = useRef(null);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        type="button"
        aria-label={t('booking.infoLabel')}
        data-testid={testId}
        className="inline-flex items-center justify-center align-middle ml-1 text-[#1E3A5F]/50 hover:text-[#D4A72C] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4A72C] rounded-full"
        onPointerDown={(e) => { pointerType.current = e.pointerType; }}
        onPointerEnter={(e) => { if (e.pointerType === 'mouse') setOpen(true); }}
        onPointerLeave={(e) => { if (e.pointerType === 'mouse') setOpen(false); }}
        onClick={(e) => {
          // Με ποντίκι το άνοιγμα γίνεται ήδη από το hover· αποφεύγουμε να κλείσει με το κλικ
          if (pointerType.current === 'mouse') e.preventDefault();
          pointerType.current = null;
        }}
      >
        <Info className="w-3.5 h-3.5" aria-hidden="true" />
      </PopoverTrigger>
      <PopoverContent
        side="top"
        className="w-64 p-3 text-xs leading-relaxed text-[#1E3A5F]"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {text}
      </PopoverContent>
    </Popover>
  );
};

export default InfoTip;
